import React, { useEffect } from "react";
import { Button, Form, Modal } from "reactstrap";
import { parseJsonRecursively } from "../../../../helperFunctions";
import { useDispatch, useSelector } from "react-redux";
import {
  getStatusCheck,
  useStatusCheck,
} from "../../../../redux/slices/payinReqResLogsSlice";
import Loader from "../../Loader";
import { useParams } from "react-router-dom";

const StatusCheckModal = ({ isOpen, onCloseModal }) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { statusDataState } = useStatusCheck();

  const { statusLoading } = useSelector((state) => state?.payinReqResLogs);
  const getStatus = async () => {
    try {
      const payload = {
        txnId: id || isOpen?.data?.payinId,
        stsUpdate: isOpen?.noUpdation,
      };
      await dispatch(getStatusCheck(payload)).unwrap();
    } catch (error) { }
  };

  useEffect(() => {
    if (isOpen) {
      getStatus();
    }
  }, [isOpen]);

  return (
    <Form>
      <Modal
        isOpen={!!isOpen}
        toggle={() => onCloseModal()}
        className="modal-width"
        centered={true}
      >
        <div className="modal-header">
          <h3 className="modal-title mt-0">Status</h3>
          <i
            onClick={() => {
              onCloseModal();
            }}
            className="fa-solid fa-xmark"
          ></i>
        </div>
        <div className="modal-body w-100">
          {statusLoading ? (
            <div className="table-loader">
              <Loader />
            </div>
          ) : (
            <div className="webevent-sec mb-1 req_text_wrap requestContainer">
              <pre>
                {Array.isArray(parseJsonRecursively(statusDataState?.data)) &&
                  parseJsonRecursively(statusDataState?.data).length === 0 ? (
                  <div>No data found</div>
                ) : (
                  <pre>{JSON.stringify?.(parseJsonRecursively(statusDataState?.data || {}), null, 2)}</pre>
                )}

              </pre>
            </div>
          )}
        </div>
        <div className="modal-footer">
          <div className="d-flex justify-content-end button-space">
            <Button className="graybutton" onClick={() => onCloseModal()}>
              Cancel
            </Button>
          </div>
        </div>
      </Modal>
    </Form>
  );
};

export default StatusCheckModal;
